import { render, staticRenderFns } from "./MetadataSearchModal.vue?vue&type=template&id=b34fbedc&scoped=true"
import script from "./MetadataSearchModal.vue?vue&type=script&lang=js"
export * from "./MetadataSearchModal.vue?vue&type=script&lang=js"
import style0 from "./MetadataSearchModal.vue?vue&type=style&index=0&id=b34fbedc&prod&lang=scss&scoped=true"
import style1 from "./MetadataSearchModal.vue?vue&type=style&index=1&id=b34fbedc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34fbedc",
  null
  
)

export default component.exports